import VueRouter from "vue-router";
const routes = [
  {
    path: "/authorLogin",
    name: "authorLogin",
    component: resolve => require(["@/views/AuthorLogin"], resolve),
  },
  {
    path: "/editLogin",
    name: "editLogin",
    component: resolve => require(["@/views/EditLogin"], resolve),
  },
  {
    path: "/expertLogin",
    name: "expertLogin",
    component: resolve => require(["@/views/ExpertLogin"], resolve),
  },
  {
    path: "/expert",
    name: "expert",
    component: resolve => require(["@/views/expert/Expert"], resolve),
    children: [
      {
        path: "/waitAudit",
        name: "/waitAudit",
        component: resolve => require(["@/views/expert/WaitAudit"], resolve),
      },
      {
        path: "/audited",
        name: "/audited",
        component: resolve => require(["@/views/expert/Audited"], resolve),
      },
      {
        path: "/expert/manager",
        name: "/expert/manager",
        component: resolve => require(["@/views/expert/Manager"], resolve),
      },
      {
        path: "/expert/preview",
        name: "/expert/preview",
        component: resolve => require(["@/views/commomon/ShowWpsFile"], resolve),
      },
    ],
  },
  {
    path: "/author",
    name: "author",
    component: resolve => require(["@/views/author/Author"], resolve),
    children: [
      {
        path: "/author/preview",
        name: "/author/preview",
        component: resolve => require(["@/views/commomon/ShowWpsFile"], resolve),
      },
      {
        path: "/author/myManuscript",
        name: "/author/myManuscript",
        component: resolve => require(["@/views/author/manuscript/MyManuscript"], resolve),
      },
      {
        path: "/contribute",
        name: "/contribute",
        component: resolve => require(["@/views/author/manuscript/Contribute"], resolve),
      },
    ],
  },
  {
    path: "/edit",
    name: "edit",
    component: resolve => require(["@/views/edit/Edit"], resolve),
    children: [
      {
        path: "/edit/preview",
        name: "/edit/preview",
        component: resolve => require(["@/views/commomon/ShowWpsFile"], resolve),
      },

      {
        path: "/register",
        name: "/register",
        component: resolve => require(["@/views/edit/editor/register/Register"], resolve),
      },
      {
        path: "/register/manager",
        name: "/register/manager",
        component: resolve => require(["@/views/edit/editor/register/Manager"], resolve),
      },
      {
        path: "/publishInfo",
        name: "/publishInfo",
        component: resolve => require(["@/views/edit/editor/deal/PublishInfo"], resolve),
      },

      {
        path: "/myManuscript",
        name: "/myManuscript",
        component: resolve => require(["@/views/edit/editor/deal/MyManuscript"], resolve),
      },
      {
        path: "/notBack",
        name: "/notBack",
        component: resolve => require(["@/views/edit/editor/deal/NotBack"], resolve),
      },
      {
        path: "/deal/manager",
        name: "/deal/manager",
        component: resolve => require(["@/views/edit/editor/deal/Manager"], resolve),
      },
      {
        path: "/back",
        name: "/back",
        component: resolve => require(["@/views/edit/editor/deal/Back"], resolve),
      },
      {
        path: "/backManager",
        name: "/backManager",
        component: resolve => require(["@/views/edit/editor/deal/BackManager"], resolve),
      },
      {
        path: "/query",
        name: "/query",
        component: resolve => require(["@/views/edit/editor/query/Query"], resolve),
      },

      {
        path: "/auditing",
        name: "/auditing",
        component: resolve => require(["@/views/edit/chief/manuscripts/Auditing"], resolve),
      },
      {
        path: "/chief/manager",
        name: "/chief/manager",
        component: resolve => require(["@/views/edit/chief/manuscripts/Manager"], resolve),
      },
      {
        path: "/chief/audited",
        name: "/chief/audited",
        component: resolve => require(["@/views/edit/chief/manuscripts/Audited"], resolve),
      },
      {
        path: "/signed",
        name: "/signed",
        component: resolve => require(["@/views/edit/chief/publish/Signed"], resolve),
      },
      {
        path: "/waitSign",
        name: "/waitSign",
        component: resolve => require(["@/views/edit/chief/publish/WaitSign"], resolve),
      },

      {
        path: "/authorManage",
        name: "/authorManage",
        component: resolve => require(["@/views/edit/editor/author/Author"], resolve),
      },
      {
        path: "/returnReceipt",
        name: "/returnReceipt",
        component: resolve => require(["@/views/commomon/ReturnReceipt"], resolve),
      },
      {
        path: "/callAudit",
        name: "/callAudit",
        component: resolve => require(["@/views/edit/editor/deal/CallAudit"], resolve),
      },

      {
        path: "/periodical",
        name: "/periodical",
        component: resolve => require(["@/views/edit/statistics/periodical"], resolve),
      },
      {
        path: "/workLoad",
        name: "/workLoad",
        component: resolve => require(["@/views/edit/statistics/workLoad"], resolve),
      },
      {
        path: "/professorCheck",
        name: "/professorCheck",
        component: resolve => require(["@/views/edit/statistics/professorCheck"], resolve),
      },
      {
        path: "/checkCycle",
        name: "/checkCycle",
        component: resolve => require(["@/views/edit/statistics/checkCycle"], resolve),
      },
      {
        path: "/publishCycle",
        name: "/publishCycle",
        component: resolve => require(["@/views/edit/statistics/publishCycle"], resolve),
      },
      {
        path: "/employRate",
        name: "/employRate",
        component: resolve => require(["@/views/edit/statistics/employRate"], resolve),
      },
      {
        path: "/layoutFee",
        name: "/layoutFee",
        component: resolve => require(["@/views/edit/statistics/layoutFee"], resolve),
      },
      {
        path: "/subjectManuscript",
        name: "/subjectManuscript",
        component: resolve => require(["@/views/edit/statistics/subjectManuscript"], resolve),
      },

      {
        path: "/basicInfo",
        name: "/basicInfo",
        component: resolve => require(["@/views/edit/system/template/BasicInfo"], resolve),
      },
      {
        path: "/email",
        name: "/email",
        component: resolve => require(["@/views/edit/system/template/Email"], resolve),
      },
      {
        path: "/addEmail",
        name: "/addEmail",
        component: resolve => require(["@/views/edit/system/template/addEmail"], resolve),
      },
      {
        path: "/checkEmail",
        name: "/checkEmail",
        component: resolve => require(["@/views/edit/system/template/CheckEmail"], resolve),
      },
      {
        path: "/shortNote",
        name: "/shortNote",
        component: resolve => require(["@/views/edit/system/template/ShortNote"], resolve),
      },
      {
        path: "/addNote",
        name: "/addNote",
        component: resolve => require(["@/views/edit/system/template/addNote"], resolve),
      },
      {
        path: "/publishPlan",
        name: "/publishPlan",
        component: resolve => require(["@/views/edit/system/periodical/PublishPlan"], resolve),
      },
      {
        path: "/columnInfo",
        name: "/columnInfo",
        component: resolve => require(["@/views/edit/system/periodical/ColumnInfo"], resolve),
      },
      {
        path: "/periodicalDoc",
        name: "/periodicalDoc",
        component: resolve => require(["@/views/edit/system/periodical/PeriodicalDoc"], resolve),
      },
      {
        path: "/role",
        name: "/role",
        component: resolve => require(["@/views/edit/system/permission/Role"], resolve),
      },
      {
        path: "/roleSet",
        name: "/roleSet",
        component: resolve => require(["@/views/edit/system/permission/RoleSet"], resolve),
      },
      {
        path: "/user",
        name: "/user",
        component: resolve => require(["@/views/edit/system/permission/User"], resolve),
      },
      {
        path: "/expertInfo",
        name: "/expertInfo",
        component: resolve => require(["@/views/edit/system/permission/Expert"], resolve),
      },
      {
        path: "/shouldKnow",
        name: "/shouldKnow",
        component: resolve => require(["@/views/edit/system/template/ShouldKnow"], resolve),
      },
      {
        path: "/submitMessage",
        name: "/submitMessage",
        component: resolve => require(["@/views/edit/system/template/SubmitMessage"], resolve),
      },
      {
        path: "/dataDic",
        name: "/dataDic",
        component: resolve => require(["@/views/edit/system/template/DataDic"], resolve),
      },
      {
        path: "/sectionDiscipline",
        name: "/sectionDiscipline",
        component: resolve => require(["@/views/edit/system/template/SectionDiscipline"], resolve),
      },
      {
        path: "/transfer",
        name: "/transfer",
        component: resolve => require(["@/views/edit/system/template/Transfer"], resolve),
      },
      {
        path: "/logInfo",
        name: "/logInfo",
        component: resolve => require(["@/views/edit/system/LoginfoList"], resolve),
      },
    ],
  },
];
const router = new VueRouter({
  routes: routes,
});
export default router;
